/**
 * Файл генерируется автоматически командой `npm run generate:advanced-filter`.
 * Не стоит его изменять руками, если вы не уверены в том, что делаете :)
 */
import { IFilter, TFilter } from '../../types/advancedFilters';
import { apartments } from './apartments';
import { urbanBathroom } from './urbanBathroom';
import { suburbanBathroom } from './suburbanBathroom';
import { ceilingHeight } from './ceilingHeight';
import { constructionType } from './constructionType';
import { constructionYear } from './constructionYear';
import { containWords } from './containWords';
import { elevators } from './elevators';
import { excludeWords } from './excludeWords';
import { flatRooms } from './flatRooms';
import { floor } from './floor';
import { floors } from './floors';
import { layout } from './layout';
import { parking } from './parking';
import { publicationDate } from './publicationDate';
import { repair } from './repair';
import { saleType } from './saleType';
import { squareMeterArea } from './squareMeterArea';
import { windows } from './windows';
import { heatingType } from './heatingType';
import { undergroundTime } from './undergroundTime';
import { demolition } from './demolition';
import { finishing } from './finishing';
import { completionYear } from './completionYear';
import { balcony } from './balcony';
import { dealType } from './dealType';
import { roomsInDeal } from './roomsInDeal';
import { suburbanUtilities } from './suburbanUtilities';
import { fromMKAD } from './fromMKAD';
import { offerType } from './offerType';
import { suburbanArea } from './suburbanArea';
import { rentTerms } from './rentTerms';
import { facilities } from './facilities';
import { bathType } from './bathType';
import { livingConditions } from './livingConditions';
import { rentalPeriod } from './rentalPeriod';
import { suburbanFacilities } from './suburbanFacilities';
import { landStatus } from './landStatus';
/* marker: prepend import */

export const ADVANCED_FILTERS: { [key in TFilter]: IFilter } = {
  apartments,
  urbanBathroom,
  suburbanBathroom,
  ceilingHeight,
  constructionType,
  constructionYear,
  containWords,
  elevators,
  excludeWords,
  flatRooms,
  floor,
  floors,
  layout,
  parking,
  publicationDate,
  repair,
  saleType,
  squareMeterArea,
  windows,
  heatingType,
  undergroundTime,
  demolition,
  finishing,
  completionYear,
  balcony,
  dealType,
  roomsInDeal,
  suburbanUtilities,
  fromMKAD,
  offerType,
  suburbanArea,
  rentTerms,
  facilities,
  bathType,
  livingConditions,
  rentalPeriod,
  suburbanFacilities,
  landStatus,
  /* marker: prepend key */
};
